<template>
  <div>
    <title-edit header="Group visit" />
    <line-hr />
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        &nbsp;
      </v-col>
      <v-col cols="12" sm="8" >
        <v-app class="switch-app">
          <v-switch label="Publish" color="tcdc_color" v-model="form.is_publish"></v-switch>
        </v-app>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Branch*</label>
      </v-col>
      <v-col cols="12" sm="8" >
        <select-option :items="optionBranch" @update="updateBranch" :model="form.branch_id" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Title TH*</label>
      </v-col>
      <v-col cols="12" sm="8" >
        <input-text-field :model="form.title_th" @update="updateTitleTH" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Title EN*</label>
      </v-col>
      <v-col cols="12" sm="8" >
        <input-text-field :model="form.title_en" @update="updateTitleEN" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Description TH*</label>
      </v-col>
      <v-col cols="12" sm="8" >
        <input-editor :model="form.description_th" @update="updateDescriptionTH" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Description EN*</label>
      </v-col>
      <v-col cols="12" sm="8" >
        <input-editor :model="form.description_en" @update="updateDescriptionEN" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Detail TH</label>
      </v-col>
      <v-col cols="12" sm="8" >
        <input-editor :model="form.detail_th" @update="updateDetailTH" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Detail EN</label>
      </v-col>
      <v-col cols="12" sm="8" >
        <input-editor :model="form.detail_en" @update="updateDetailEN" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Message TH</label>
      </v-col>
      <v-col cols="12" sm="8" >
        <input-editor :model="form.message_th" @update="updateMessageTH" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Message EN</label>
      </v-col>
      <v-col cols="12" sm="8" >
        <input-editor :model="form.message_en" @update="updateMessageEN" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Contact email*</label>
      </v-col>
      <v-col cols="12" sm="8" >
        <input-text-field :model="form.contact_email" @update="updateContactEmail" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Contact info*</label>
      </v-col>
      <v-col cols="12" sm="8" >
        <input-text-area :model="form.contact_info" @update="updateContactInfo" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Slug Url</label>
      </v-col>
      <v-col cols="12" sm="8" >
        <input-text-field :model="form.slug_url" @update="updateSlugUrl" />
      </v-col>
    </div>
    <line-hr />
    <command-button @delete-info="deleteGroupVisit" @save-info="saveGroupVisit" @save-close="saveClose"></command-button>
  </div>
</template>

<script>
import TitleEdit from "../../../components/TitleHeader/TitleEdit";
import LineHr from "../../../components/Icon/line-hr";
import SelectOption from "../../../components/Input/selectOption";
import InputTextField from "../../../components/Input/InputTextField";
import SaveButton from "../../../components/Button/SaveButton";
import PreviewButton from "../../../components/Button/PreviewButton";
import DeleteButton from "../../../components/Button/DeleteButton";
import { mapState } from "vuex";
import InputEditor from "../../../components/Input/InputEditor";
import InputTextArea from "../../../components/Input/InputTextArea";
import {permissionGroupVisit, role} from "../../../util/Permission";
import Swal from "sweetalert";
import CommandButton from "../../../components/Layout/CommandButton";

export default {
  name: "GroupVisitEdit",
  components: {
    CommandButton,
    InputTextArea,
    InputEditor,
    DeleteButton,
    PreviewButton,
    SaveButton,
    InputTextField,
    SelectOption,
    LineHr,
    TitleEdit
  },
  created() {
    this.permission = role;
    this.getBranchData();
  },
  computed: {
    permissionGroupVisit,
    ...mapState({
      form: state => {
        return state.GroupVisit.form;
      }
    })
  },
  data() {
    return {
      optionBranch: [],
      permission : null,
      save_id: null
    };
  },
  methods: {
    getBranchData() {
      this.$store.dispatch("Branch/getBranchAll").then(res => {
        this.optionBranch = [
          { text: "Select", value: "" },
          ...res.filter(val => val.branch_id !== 0).map(type => ({
            value: type.branch_id,
            text: type.branch_name_th + " (" + type.branch_name_en + ")"
          }))
        ];
      });
    },
    saveClose() {
      this.$store
              .dispatch("GroupVisit/saveGroupVisit", {
                id: this.save_id ? this.save_id : this.form.id,
                data: this.form
              })
              .then(res => {
                Swal(res.response_msg);
                if (res.response_code == 200) {
                  this.goToGroupVisitTable();
                }
              })
              .catch(() => {
                Swal('','Cannot save group visit data!','error');
              });
    },
    saveGroupVisit() {
      this.$store
        .dispatch("GroupVisit/saveGroupVisit", {
          id: this.save_id ? this.save_id : this.form.id,
          data: this.form
        })
        .then(res => {
          this.save_id = res.result.id;
          Swal(res.response_msg);
        })
        .catch(() => {
          Swal('','Cannot save group visit data!','error');
        });
    },
    deleteGroupVisit() {
      this.$store
        .dispatch("GroupVisit/deleteGroupVisit", this.form.id)
        .then(res => {
          Swal(res.response_msg);
          if (res.response_code == 200) {
            this.goToGroupVisitTable();
          }
        })
        .catch(() => {
          Swal('','Cannot delete group visit data!','error');
        });
    },
    goToGroupVisitTable() {
      this.$router.push("/services/group-visit");
    },
    updateBranch(val) {
      this.form.branch_id = val;
    },
    updateTitleEN(val) {
      this.form.title_en = val;
    },
    updateTitleTH(val) {
      this.form.title_th = val;
    },
    updateDescriptionEN(val) {
      this.form.description_en = val;
    },
    updateDescriptionTH(val) {
      this.form.description_th = val;
    },
    updateDetailEN(val) {
      this.form.detail_en = val;
    },
    updateDetailTH(val) {
      this.form.detail_th = val;
    },
    updateMessageEN(val) {
      this.form.message_en = val;
    },
    updateMessageTH(val) {
      this.form.message_th = val;
    },
    updateContactInfo(val) {
      this.form.contact_info = val;
    },
    updateContactEmail(val) {
      this.form.contact_email = val;
    },
    updateSlugUrl(val) {
      this.form.slug_url = val;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "src/assets/css/variables.scss";
@import "../../../assets/css/switch.css";
</style>
